import { ballArr, count, singleDouble, singleDoubleCnname, smallBig, continuity, continuityCnname, smallBigCnname, dragonTiger, fishCnname } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';

const ks = (data, ballindex) => {
  let list = Vue => {
    var ball = ['一', '二', '三', '四', '五'];
    let arr = [
      {
        title: '期数',
        align: 'center',
        key: 'issue_id',
        className: `table_issueId`,
        width: 120
      },

      {
        title: '开奖时间',
        align: 'center',
        key: 'result_time',
        className: `table_issueId`,
        width: 125,
        render: (h, { row }) => {
          return <span>{row.result_time.split(' ')[1]}</span>;
        }
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 172,
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div class="pk_balls">
              {row.balls.split(',').map((x, i) => {
                return <span class={`ball_red_${i}`}>{x}</span>;
              })}
            </div>
          );
        }
      },
      {
        title: `冠亚和`,
        align: 'center',
        width: 70,
        className: `table_issueId`,
        render: (h, { row }) => <span>{row.sum_json.guanyaSum}</span>
      }
    ];
    var a = data[0].sum_json.guanya;
    var keys = Object.keys(a);
    for (let i = 0; i < keys.length; i++) {
      var obj = {};
      obj.title = `${keys[i]}`;
      obj.align = 'center';
      obj.render = (h, row) => {
        var num = row.row.sum_json.guanya[keys[i]];
        if (num == 0) {
          return <span class="red">{row.row.sum_json.guanyaSum}</span>;
        } else if (Vue.divideList[keys[i]] > row.index) {
          return <span class="divide_lost_info lost_info">{num}</span>;
        } else {
          return <span class="lost_info">{num}</span>;
        }
        // return <span class="lost_info">{num}</span>;
      };
      arr.push(obj);
    }

    return arr;
  };
  let lostList = Vue => {
    let arr = [
      {
        title: '数据统计',
        align: 'center',
        key: 'name',
        className: `table_issueId`,
        width: 487
      }
    ];

    var a = data[0].sum_json.guanya;
    var keys = Object.keys(a);
    for (let i = 0; i < keys.length; i++) {
      var obj = {};
      obj.title = `${keys[i]}`;
      obj.align = 'center';
      obj.render = (h, row) => {
        // return <span>3</span>;
        // var name = `ball${index + 1}`;
        var key = row.row.key;
        var n = row.row.lost.sumJson.guanya;
        if (key != 'averageOmit') {
          return <span>{n[keys[i]][key] ? n[keys[i]][key] : 0}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  };
  return { list, lostList };
};

export default ks;



// WEBPACK FOOTER //
// ./src/pages/Trend/Hezhizoushi/columns/pk10.js